module.exports = __webpack_public_path__ + "static/media/baseball.231ff8d1.svg";